
    import { Component, Mixins, Prop } from 'vue-property-decorator';
    import { CheckboxFilterMixin } from '@entrypointdev/datatables.net-vue';

    @Component
    export default class FilterCheckbox extends Mixins(CheckboxFilterMixin) {
        @Prop({ type: String, default: '' })
        protected size!: string;
    }
